import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from './styles.module.scss';

const LabelHello = ({name}) => {
  const getLabelByNameAndDatetime = (name, dateTime) => {
    const currentHour = moment(dateTime).hour();

    if (currentHour >= 6 && currentHour < 12) {
      return `בוקר טוב ${name}`; //morning
    } else if (currentHour >= 12 && currentHour < 16) {
      return `צהריים טובים ${name}`; // noon
    } else {
      return `ערב טוב ${name}`;
    }
  };

  return (
    <div className={styles.tagline}>
      {getLabelByNameAndDatetime(name, new Date())}
    </div>
  );
};

LabelHello.propTypes = {
  name: PropTypes.string,
};

export default LabelHello;
